'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWatch, iconWatchTag } from '@ni/nimble-components/dist/esm/icons/watch';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWatch };
export { iconWatchTag };
export const NimbleIconWatch = wrap(IconWatch);